import { createAction } from 'store/utils';
import {
  GET_CHART_OF_ACCOUNTS_TEMPLATES_FAILURE,
  GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST,
  GET_CHART_OF_ACCOUNTS_TEMPLATES_SUCCESS,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_FAILURE,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_SUCCESS,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_SUCCESS,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_FAILURE,
  SAVE_CHART_OF_ACCOUNTS_FAILURE,
  SAVE_CHART_OF_ACCOUNTS_REQUEST,
  SAVE_CHART_OF_ACCOUNTS_SUCCESS,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS,
  UPDATE_CHART_OF_ACCOUNTS_FOR_CONNECTION,
  DELETE_CHART_OF_ACCOUNT_ROW_REQUEST,
  DELETE_CHART_OF_ACCOUNT_ROW_SUCCESS,
  DELETE_CHART_OF_ACCOUNT_ROW_FAILURE,
  DELETE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
  DELETE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS,
  DELETE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_SUCCESS,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_FAILURE,
} from './constants';
import { CoaAccountRow, CoaTemplate } from './models';

export const fetchChartOfAccountsTemplatesRequest = () =>
  createAction(GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST);

export const fetchChartOfAccountsTemplatesSuccess = (
  templates: CoaTemplate[]
) =>
  createAction(GET_CHART_OF_ACCOUNTS_TEMPLATES_SUCCESS, {
    templates,
  });

export const fetchChartOfAccountsTemplatesFailure = () =>
  createAction(GET_CHART_OF_ACCOUNTS_TEMPLATES_FAILURE);

export const fetchChartOfAccountsByCountryRequest = (countryId: string) =>
  createAction(FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST, { countryId });

export const fetchChartOfAccountsByCountrySuccess = (
  countryId: string,
  chartOfAccounts: any
) =>
  createAction(FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_SUCCESS, {
    countryId,
    chartOfAccounts,
  });

export const fetchChartOfAccountsByCountryFailure = () =>
  createAction(FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_FAILURE);

export const fetchChartOfAccountsForOrganisationRequest = (
  organisationId: string
) =>
  createAction(FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST, {
    organisationId,
  });

export const fetchChartOfAccountsForOrganisationSuccess = (
  organisationId: string,
  accounts: CoaAccountRow[]
) =>
  createAction(FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_SUCCESS, {
    organisationId,
    accounts,
  });

export const fetchChartOfAccountsForOrganisationFailure = () =>
  createAction(FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_FAILURE);

export const saveChartOfAccountsRequest = (
  organisationId: string,
  accountIds: string[]
) =>
  createAction(SAVE_CHART_OF_ACCOUNTS_REQUEST, {
    organisationId,
    accountIds,
  });

export const saveChartOfAccountsSuccess = () =>
  createAction(SAVE_CHART_OF_ACCOUNTS_SUCCESS);

export const saveChartOfAccountsFailure = () =>
  createAction(SAVE_CHART_OF_ACCOUNTS_FAILURE);

export const saveChartOfAccountsTemplateRequest = (
  organisationId: string,
  name: string,
  accountIds: string[]
) =>
  createAction(SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST, {
    organisationId,
    name,
    accountIds,
  });

export const saveChartOfAccountsTemplateSuccess = () =>
  createAction(SAVE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS);

export const saveChartOfAccountsTemplateFailure = () =>
  createAction(SAVE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE);

export const updateChartOfAccountsForConnection = (
  connectionId: string,
  accounts: CoaAccountRow[]
) =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_FOR_CONNECTION, {
    connectionId,
    accounts,
  });

export const deleteChartOfAccountRowRequest = (
  organisationId: string,
  accountId: string
) =>
  createAction(DELETE_CHART_OF_ACCOUNT_ROW_REQUEST, {
    organisationId,
    accountId,
  });

export const deleteChartOfAccountRowSuccess = () =>
  createAction(DELETE_CHART_OF_ACCOUNT_ROW_SUCCESS);

export const deleteChartOfAccountRowFailure = () =>
  createAction(DELETE_CHART_OF_ACCOUNT_ROW_FAILURE);

export const deleteChartOfAccountsTemplateRequest = (templateId: string) =>
  createAction(DELETE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST, { templateId });

export const deleteChartOfAccountsTemplateSuccess = () =>
  createAction(DELETE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS);

export const deleteChartOfAccountsTemplateFailure = () =>
  createAction(DELETE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE);

export const createChartOfAccountsCustomRowRequest = (
  organisationId: string,
  row: CoaAccountRow
) =>
  createAction(CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST, {
    organisationId,
    row,
  });

export const createChartOfAccountsCustomRowSuccess = () =>
  createAction(CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS);

export const createChartOfAccountsCustomRowFailure = () =>
  createAction(CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE);

export const updateChartOfAccountsCustomRowRequest = (
  organisationId: string,
  row: CoaAccountRow
) =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST, {
    organisationId,
    row,
  });

export const updateChartOfAccountsCustomRowSuccess = () =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS);

export const updateChartOfAccountsCustomRowFailure = () =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE);

export const updateChartOfAccountsTemplateNameRequest = (
  templateId: string,
  name: string
) =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST, {
    templateId,
    name,
  });

export const updateChartOfAccountsTemplateNameSuccess = () =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_SUCCESS);

export const updateChartOfAccountsTemplateNameFailure = () =>
  createAction(UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_FAILURE);
